

function HeaderStep({ title }) { // component to manage the first step of shopping : choosing place and time


    return (
        <div className="header-step-manager">

            <div className="header-step-manager-left">

                <h2 className="header-step-title">{title}</h2>
            </div>


        </div>

    )
}




export default HeaderStep